// src/js/form.js
import { submitUserDetails } from './api.js';

export async function submitDetails() {
  const location = document.getElementById('customerLocation').value;
  const pincode = document.getElementById('customerPincode').value;
  const mobile = document.getElementById('customerMobile').value;
  const status = document.getElementById('status');

  if (!mobile) {
    status.textContent = "Please fill Mobile number.";
    status.style.color = "red";
    return;
  }

  status.textContent = "Submitting...";

  try {
    const response = await submitUserDetails({
      location,
      pinCode: pincode,
      mobileNumber: mobile
    });

    if (response.ok) {
      status.textContent = "Details submitted successfully!";
      status.style.color = "green";
    } else {
      status.textContent = "Failed to submit details.";
      status.style.color = "red";
    }
  } catch (error) {
    status.textContent = "Something went wrong!";
    status.style.color = "red";
  }
}
